export default class NullHelper {
  constructor () {
    throw 'Não é possível instanciar NullHelper'
  }

  static valora (prop, modelo) {
    const copiaModelo = JSON.parse(JSON.stringify(modelo))
    return !prop ? copiaModelo : prop
  }

  static reseta (prop, modelo) {
    const propString = JSON.stringify(prop)
    const modeloString = JSON.stringify(modelo)
    const continuaVazio = Object.is(propString, modeloString)
    return continuaVazio ? null : prop
  }
}


// WEBPACK FOOTER //
// ./src/helpers/NullHelper.js